export default __webpack_public_path__ + "static/media/cvod-m.728d3726.svg";